<template>
    <span v-html="value"/>
</template>

<script>
export default {
    name: "TableCellTypeColor",
    props: {
        value: String,
        item: Object,
    },
}
</script>

<style scoped>

</style>